import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';

const BookSessionCTA = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-[#00E5FF]/5 via-[#0B0F1A] to-[#1DE9B6]/5"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#00E5FF] rounded-full blur-[250px] opacity-[0.04]"></div>

      <div className="max-w-4xl mx-auto relative z-10">
        <div className="bg-gradient-to-br from-[#111827] to-[#0B0F1A] border-2 border-[#00E5FF]/20 rounded-2xl p-10 sm:p-14 text-center hover:border-[#00E5FF]/40 transition-all duration-500" data-testid="book-session-cta">
          <div className="inline-flex items-center gap-2 bg-[#00E5FF]/10 border border-[#00E5FF]/30 rounded-full px-4 py-2 mb-6">
            <Sparkles className="w-4 h-4 text-[#00E5FF]" />
            <span className="text-[#00E5FF] text-sm font-medium">Free Career Guidance</span>
          </div>

          <h2 className="text-3xl sm:text-4xl font-bold mb-4 font-['Space_Grotesk']">
            Confused About Your Career in <span className="bg-gradient-to-r from-[#00E5FF] to-[#1DE9B6] bg-clip-text text-transparent">Data & AI?</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-[#00E5FF] to-transparent mx-auto mb-6"></div>

          <p className="text-[#9CA3AF] text-base sm:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
            Get a personalized roadmap from industry experts. Understand which skills, certifications, and career paths are right for you — completely free.
          </p>

          <Link to="/book-a-consultation">
            <Button className="bg-[#00E5FF] hover:bg-[#1DE9B6] text-[#0B0F1A] font-bold px-10 py-6 text-base rounded-xl shadow-lg shadow-[#00E5FF]/40 hover:shadow-[#00E5FF]/60 transition-all duration-300 hover:scale-105" data-testid="book-session-btn">
              Book Free Career Call <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </Link>

          <p className="text-[#9CA3AF]/60 text-xs mt-4">No fees. No commitments. Just expert advice.</p>
        </div>
      </div>
    </section>
  );
};

export default BookSessionCTA;
